import VueSocketIO from 'vue-socket.io';
import Vue from 'vue';
var VUE_APP_SOCKET_CONNECT = process.env.VUE_APP_SOCKET_CONNECT;
export default function initSocket() {
  var projectId = window.GLOBAL_CONFIG.projectId; // projectId = 1
  // VUE_APP_SOCKET_CONNECT = 'wss://socketmsg.istrongcloud.com'

  var socketConstruct = new VueSocketIO({
    debug: true,
    // 服务器端地址
    connection: "".concat(VUE_APP_SOCKET_CONNECT, "?loginUserCompanyId=").concat(projectId),
    vuex: {}
  });
  Vue.use(socketConstruct);
}